import $ from 'jquery';

export default function sortBy() {
    let $element = $('.js-c-sortby'),
        $trigger = $element.find('.c-sortby__trigger'),
        $actions = $element.find('.c-sortby__action');

    $trigger.on('click', function() {
        $element.toggleClass('is-open');
    });

    var mql = window.matchMedia("(min-width: 781px)");
    mql.addListener(handleResize);
    handleResize(mql);

    function handleResize(mql) {
        if (mql.matches) {
            if($element.hasClass('is-open')) {
                $element.removeClass('is-open');
            }
        }
    }
}